import {openLightbox} from 'wix-window';
import {log, savePolicy } from 'public/biLogger';

const switchId = '#switch1';
$w.onReady(function () {
	$w(switchId).onChange(()=> {
    toggelAction();
	});

	$w("#button1").onClick(()=> {
		saveAction();
	});
});

function toggelAction(){
  const transferToThirdParty = $w("#switch1").checked;
  toggleBi(transferToThirdParty);
  if(!transferToThirdParty){
    openLightbox('CCPA Settings').then(lightBoxDecisionHandler);
  }
}

function lightBoxDecisionHandler(advertisingDecision){
  let action = advertisingDecision && advertisingDecision.action || 'dismiss';
  log({ evid: 818, action });
  if(action === 'ok'){
    $w(switchId).checked = true;
  }
}

function saveAction(){
  const advertising = $w(switchId).checked;
  savePolicy(advertising);
  saveBi(advertising);
}

function toggleBi(advertising){
	log({action: 'toggle', toggle: advertising, evid: 817});
}

function saveBi(advertising){
	log({ action: 'save', toggle: advertising, evid: 817});
}
